export default { PACKAGE_VERSION: "1.13.0" };
